import { render, staticRenderFns } from "./index.vue?vue&type=template&id=681b134f"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=681b134f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HeaderDiploma: require('/home/apprentissage-montpellier/www/prod/AM-frontend/components/HeaderDiploma.vue').default,ErrorFieldHandler: require('/home/apprentissage-montpellier/www/prod/AM-frontend/components/ErrorFieldHandler.vue').default,FormErrorPopUp: require('/home/apprentissage-montpellier/www/prod/AM-frontend/components/FormErrorPopUp.vue').default})
